<template>
  <label
    class="relative inline-flex h-4 w-8 shrink-0 cursor-pointer items-center justify-center rounded-full outline-offset-2 outline-yellow-500 focus-within:outline-2"
  >
    <span
      aria-hidden="true"
      class="absolute mx-auto h-3 w-7 rounded-full bg-gray-200 shadow-inner transition-colors duration-200 ease-in-out"
      :class="{ 'bg-yellow-500': isChecked }"
    ></span>
    <span
      aria-hidden="true"
      class="absolute left-0 h-4 w-4 rounded-full border border-gray-300 bg-white shadow-xs transition-transform duration-200 ease-in-out"
      :class="{ 'translate-x-4': isChecked }"
    ></span>
    <input
      type="checkbox"
      role="switch"
      class="absolute inset-0 h-full w-full cursor-pointer appearance-none focus:outline-hidden"
      :checked="isChecked"
      :aria-checked="isChecked ? 'true' : 'false'"
      :aria-label="ariaLabel"
      @change="onChange"
    >
  </label>
</template>

<script>
export default {
  name: 'MosCheckSwitch',
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: String,
      default: 'MOS Check/Uncheck',
    },
  },
  data() {
    return {
      isChecked: this.checked,
    };
  },
  watch: {
    checked(value) {
      this.isChecked = value;
    },
  },
  methods: {
    onChange(event) {
      this.isChecked = event.target.checked;
      this.$emit('change', this.isChecked);
    },
  },
};
</script>
